export const dateOfBirthMixin = {
    data() {
        return {
            manualDate:{
                day: "",
                month: "",
                year: ""
            },
        };
    },
    computed:{
        days() {
            return Array.from({ length: 31 }, (_, index) => {
                const dayValue = index + 1;
                return {
                    value: dayValue,
                    label: dayValue.toString().padStart(2, '0')
                };
            });
        },
        months() {
            const monthNames = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
            return Array.from({ length: 12 }, (_, index) => {
                const monthValue = index + 1;
                return {
                    value: monthValue,
                    label: monthNames[index]
                };
            });
        },
        years() {
            let factor = 0;
            let startYear = new Date().getFullYear() - factor;
            return Array.from({ length: 100 }, (_, index) => {
                const yearValue = startYear - index;
                return {
                    value: yearValue,
                    label: yearValue.toString()
                };
            });
        },
    },
    methods: {
        createDOB(){
            var inputDate = this.manualDate;
            if(!inputDate.day || !inputDate.month || !inputDate.year){
                this.data.dob = ""; return;
            }
            var date = new Date(inputDate.year, inputDate.month - 1, inputDate.day);
            this.data.dob =  date;
            if ('age' in this.data) {
                var age = this.$filters.calculateAge(date);
                this.data.age = age > 1 ? age : 1;
            }
        },
    },
};